import { createReducer } from '@reduxjs/toolkit';
import { changeActivePage, setAgreement } from './action';

const initialPage = window.location.pathname;

const getInitialAgreement = () => {
	const savedAgreement = localStorage.getItem('isCookieAgree');
	return savedAgreement ? JSON.parse(savedAgreement) : true;
};

const initialState = {
	isActivePage: initialPage,
	isAgree: getInitialAgreement(),
};

const data = createReducer(initialState, (builder) => {
	builder
		.addCase(changeActivePage, (state, action) => {
			state.isActivePage = action.payload;
		})
		.addCase(setAgreement, (state, action) => {
			state.isAgree = action.payload;
			localStorage.setItem('isCookieAgree', JSON.stringify(action.payload));
		});
});

export { data };



